// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1Be_7","cell":"ColumnAccessor_cell__1CCHV","firstCellAccent":"ColumnAccessor_firstCellAccent__3UC3X"};